export const generalContent = {
    registryName: "CADR Registry",
    registryTagLine: "Buy, sell and collect CADRs.",
    primaryAsset: "CADR",
    registryOwner: "Carbon Pump"
};